/* Core & libraries */
import url from "url";
import querystring from "querystring";
import qs from "qs";

/* Helpers, constants, custom methods, internal libraries */
import { getLang } from "../helpers/general";
import { API_PROTOCOL, API_HOST } from "../constants/appConstants";
import useAxiosInstance from "../hoc/withErrorHandling";
import {useSpinnersUpdateContext} from "../contexts/spinnersContext";

/* Components */
/* Styles */

export const useGenericApiFetch = () => {

  const axiosApiInstance = useAxiosInstance();
  const setSpinner = useSpinnersUpdateContext();

  const buildPath = (resource, host) => {
    const currentRequest = {
      pathname: resource,
      protocol: API_PROTOCOL,
      host: host ? host : API_HOST,
      // search: querystring.stringify(parameters),
    };
    return url.format(currentRequest);
  };

// function to handle requests towards backend
  const genericApiFetch = async (params) => {
    const { url, method, data, headers, queryParams, spinner, host, responseType = "json" } = params;
    const URL = buildPath(url, host);

    const axiosHeaders = {...headers, ...{'Accept-Language': getLang()}};

    if(spinner) {
      setSpinner({
        [spinner]: true
      })
    }
    const options = {
      url: `${URL}`,
      method: method,
      data: data,
      headers: axiosHeaders,
      withCredentials: true,
      params: queryParams,
      responseType: responseType,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: "repeat" }),
    };
    const axiosPromise = await axiosApiInstance(options);
    if(spinner) {
      setSpinner({
        [spinner]: false
      })
    }
    return axiosPromise;
  };
  return { genericApiFetch };
}
